<button
  #openInfoModalButton
  *ngIf="!hideTooltip"
  class="info-link font-body-1 nordic-blue-900-text block ms-xlarge-b medium-type"
  (click)="openInfoModal($event)"
>
  <span class="underline">{{ 'plus.transactionHistory.popupButton' | finLocalization }}</span>
  <fcom-icon aria-hidden="true" class="icon-medium" [name]="SvgLibraryIcon.HELP_BLOCK"></fcom-icon>
</button>
<p *ngIf="(status$ | async) === Status.EMPTY" class="mr-small-b block ms-xlarge-t">
  {{ 'plus.transactionHistory.noTransactions' | finLocalization }}
</p>
<div class="nordic-blue-900-text font-body-1 fill align-center" *ngIf="(status$ | async) === Status.LOADING">
  <p>{{ 'plus.transactionHistory.loading' | finLocalization }}</p>
  <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT"> </fcom-loader>
</div>

<div
  class="enable-loyalty-overhaul"
  *ngIf="visibleTransactions$ | async as visibleTransactions"
  data-enable-loyalty-overhaul
>
  <div *ngIf="visibleTransactions.length > 0" class="border rounded-large overflow-hidden">
    <table class="transactions-table fill">
      <caption class="is-vishidden">
        {{
          hiddenCaptionText
        }}
      </caption>
      <thead class="font-body-1">
        <th scope="col" class="description-cell white-bg ps-small-x ps-small-y">
          <span [innerHTML]="'plus.transactionHistory.description' | finLocalization"></span>
        </th>
        <th scope="col" class="points-cell white-bg pr-medium-l ps-small-y ps-small-r mr-xsmall-r">
          <span [innerHTML]="'LOYALTY.plus.transactionHistory.aviosPoints' | finLocalization"></span>
        </th>
        <th scope="col" class="points-cell white-bg pr-medium-l ps-small-y ps-small-r">
          <span [innerHTML]="'plus.transactionHistory.tier' | finLocalization"></span>
        </th>
      </thead>
      <tbody class="border-top" data-testid="transactions-table">
        <ng-container *ngFor="let transaction of visibleTransactions; let i = index; let last = last">
          <tr
            #transactionRow
            class="font-body-1 link-hover"
            [class.border-bottom]="!last"
            (click)="openTransactionModal($event, transaction)"
            (keydown.enter)="openTransactionModal($event, transaction)"
            [id]="'transaction-row-' + transaction.id"
            [attr.style]="transaction.animationOrder ? '--animation-order: ' + transaction.animationOrder + ';' : null"
            tabindex="0"
          >
            <!--Start of description-->
            <td class="description-cell ps-small-y">
              <span class="date font-body-2 regular-type ps-small-l pr-xsmall-r">
                {{ transaction.date | finDateFormat: 'DATE' }}
              </span>
              <span
                class="description font-body-1 bold-type truncate overflow-hidden ps-small-l pr-xsmall-r"
                [ngClass]="{
                  'heather-700-text':
                    transaction.status === TransactionStatus.CANCELLED ||
                    transaction.status === TransactionStatus.PARTNER_REJECT,
                  'nordic-blue-900-text':
                    transaction.status === TransactionStatus.PROCESSED ||
                    transaction.status === TransactionStatus.PARTNER_PENDING,
                }"
              >
                {{ transaction.description }}
              </span>
            </td>
            <!--End of description-->
            <!--Start of points-->
            <td class="points-cell font-body-1 medium-type pr-medium-l ps-small-y ps-small-r">
              <span
                *ngIf="
                  transaction.status !== TransactionStatus.PARTNER_PENDING &&
                  transaction.status !== TransactionStatus.PARTNER_REJECT
                "
                [ngClass]="{
                  'heather-700-text': transaction.status !== TransactionStatus.PROCESSED,
                  'nordic-blue-900-text': transaction.status === TransactionStatus.PROCESSED,
                }"
                class="award-points"
              >
                {{
                  transaction.awardPoints === '0'
                    ? '0'
                    : transaction.isAviosTransaction
                      ? (transaction.awardPoints | finPoints)
                      : (transaction.awardPoints | finPoints) +
                        ' ' +
                        ('plus.transactionHistory.awardPointType' | finLocalization)
                }}
              </span>
            </td>
            <td class="points-cell font-body-1 medium-type pr-medium-l ps-small-y ps-small-r">
              <span
                *ngIf="
                  transaction.status !== TransactionStatus.PARTNER_PENDING &&
                  transaction.status !== TransactionStatus.PARTNER_REJECT
                "
                class="tier-points align-center"
              >
                {{
                  transaction.tierPoints === '0'
                    ? '0'
                    : transaction.isAviosTransaction
                      ? (transaction.tierPoints | finPoints)
                      : (transaction.tierPoints | finPoints) +
                        ' ' +
                        ('plus.transactionHistory.tierPointType' | finLocalization)
                }}
              </span>
              <span *ngIf="transaction.status === TransactionStatus.PARTNER_PENDING">
                {{ 'plus.transactionHistory.pointsPending' | finLocalization }}
              </span>
              <span *ngIf="transaction.status === TransactionStatus.PARTNER_REJECT">
                {{ 'plus.transactionHistory.rejectedRequest' | finLocalization }}
              </span>
            </td>
            <!--End of points-->
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <ng-container *finLet="status$ | async as status">
    <fcom-notification
      *ngIf="status === Status.ERROR"
      aria-live="assertive"
      class="pr-small-y"
      [theme]="NotificationTheme.ALERT"
      [layout]="NotificationLayout.BLOCK"
      [isClosable]="true"
      [i18n]="{ closeAriaLabel: 'plus.profile.closeNotification' }"
      (closeClick)="onCloseNotification()"
    >
      {{ 'plus.transactionHistory.error' | finLocalization }}
    </fcom-notification>
    <div *ngIf="visibleTransactions.length > 0 && !loadingDisabled" class="ms-medium-t flex flex--middle flex--end">
      <fcom-button
        [text]="'plus.transactionHistory.loadMore' | finLocalization"
        [loading]="status === Status.LOADING"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.RIGHT }"
        [type]="ButtonType.BUTTON"
        (clickBtn)="onLoadMoreTransactions(visibleTransactions)"
        data-testid="load-more-button"
      >
      </fcom-button>
    </div>
  </ng-container>

  <div *ngIf="showFullHistoryLink" class="transaction-link--wrapper align-right ms-large-t">
    <a
      data-testid="full-history-link"
      class="nordic-blue-900-text font-body-1 medium-type"
      [finLink]="
        '/' +
        (currentLanguage$ | async) +
        '/' +
        LoyaltyRoutesPath.PLUS +
        '/' +
        LoyaltyRoutesPath.BALANCE_AND_TRANSACTIONS
      "
    >
      <span>{{ 'plus.transactionHistory.fullTransactionLink' | finLocalization }}</span>
      <fcom-icon
        aria-hidden="true"
        class="transaction-link--icon icon-medium"
        [name]="SvgLibraryIcon.ARROW_RIGHT"
      ></fcom-icon>
    </a>
  </div>
</div>

<span class="is-vishidden" aria-live="polite" [ngSwitch]="status$ | async">
  <ng-container *ngSwitchCase="Status.INITIAL"></ng-container>
  <ng-container *ngSwitchCase="Status.LOADING">{{ 'plus.transactionHistory.loading' | finLocalization }}</ng-container>
  <ng-container *ngSwitchCase="Status.COMPLETE">
    {{ 'plus.transactionHistory.rowsAdded' | finLocalization: { amount: a11yStatusAddedRowsAmount } }}</ng-container
  >
  <ng-container *ngSwitchCase="Status.ERROR">{{ 'plus.transactionHistory.error' | finLocalization }}</ng-container>
  <ng-container *ngSwitchCase="Status.ALL_LOADED">
    {{ 'plus.transactionHistory.allTransactionsloaded' | finLocalization }}</ng-container
  >
</span>

<fcom-modal
  *finLet="modalTransaction$ | async as transaction"
  [title]="transaction?.description"
  [buttons]="ModalButtons.CLOSE"
  [(open)]="isTransactionModalOpen"
  (close)="closeTransactionModal(transaction?.id)"
>
  <fin-loader *ngIf="(templateTransaction$ | async) === null" [type]="LoaderType.INLINE"></fin-loader>
  <fcom-notification
    *ngIf="(templateTransaction$ | async)?.status === TransactionStatus.PARTNER_PENDING"
    class="ps-large font-body-1 light-type"
  >
    {{ 'plus.transactionHistory.modal.pointsPending' | finLocalization }}
  </fcom-notification>
  <div *ngIf="templateTransaction$ | async as templateTransaction" class="ps-large font-body-1 light-type">
    <!--Start of date and type-->
    <table class="fill ms-large-b">
      <caption class="nordic-blue-900-text bold-type align-left ps-small-b">
        {{
          'plus.transactionHistory.modal.dateAndType.heading' | finLocalization
        }}
      </caption>
      <tr>
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.dateAndType.date' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.date | finDateFormat: 'DATE' }}</td>
      </tr>
      <tr>
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.dateAndType.type' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.productType }}</td>
      </tr>
    </table>

    <!--End of date and type-->
    <div class="border-top-dashed fill"></div>
    <!--Start of description-->
    <table class="fill ms-large-b">
      <caption class="nordic-blue-900-text ps-large-t align-left bold-type ps-small-b">
        {{
          'plus.transactionHistory.modal.description.heading' | finLocalization
        }}
      </caption>
      <tr *ngIf="templateTransaction.origin">
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.description.from' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.origin }}</td>
      </tr>
      <tr *ngIf="templateTransaction.destination">
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.description.to' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.destination }}</td>
      </tr>
      <tr *ngIf="templateTransaction.flight && templateTransaction.partnerName">
        <th scope="row" class="align-left ps-small-y">
          {{ 'plus.transactionHistory.modal.description.flightNumber' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.partnerName }} {{ templateTransaction.flight }}</td>
      </tr>
      <tr
        *ngIf="
          templateTransaction.partner && templateTransaction.productType !== TransactionProductType.ELECTRONIC_VOUCHER
        "
      >
        <th
          scope="row"
          *ngIf="templateTransaction.productType === TransactionProductType.AIRLINE_AWARD"
          class="align-left ps-xsmall-y"
        >
          {{ 'plus.transactionHistory.modal.description.operated' | finLocalization }}
        </th>
        <th
          scope="row"
          *ngIf="templateTransaction.productType === TransactionProductType.AIRLINE_FLIGHT"
          class="align-left ps-xsmall-y"
        >
          {{ 'plus.transactionHistory.modal.description.marketed' | finLocalization }}
        </th>
        <th
          scope="row"
          *ngIf="
            templateTransaction.productType !== TransactionProductType.AIRLINE_AWARD &&
            templateTransaction.productType !== TransactionProductType.AIRLINE_FLIGHT
          "
          class="align-left ps-xsmall-y"
        >
          {{ 'plus.transactionHistory.modal.description.partnerName' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.partner.name }}</td>
      </tr>
      <tr *ngIf="templateTransaction.ticketNumber">
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.description.ticket' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.ticketNumber }}</td>
      </tr>
      <tr
        *ngIf="
          templateTransaction.fareFamily && templateTransaction.partner && templateTransaction.partner.code === 'AY'
        "
      >
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.description.ticketType' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.fareFamily }}</td>
      </tr>
      <tr *ngIf="templateTransaction.travelClass">
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.description.travelClass' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.travelClass }}</td>
      </tr>
      <tr *ngIf="templateTransaction.bookingClass">
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.description.bookingClass' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.bookingClass }}</td>
      </tr>
      <tr *ngIf="templateTransaction.status === TransactionStatus.PARTNER_REJECT">
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.description.description' | finLocalization }}
        </th>
        <td class="medium-type align-right">
          {{ 'plus.transactionHistory.modal.description.rejected' | finLocalization }}
        </td>
      </tr>
      <tr
        *ngIf="
          !(
            templateTransaction.productType === TransactionProductType.AIRLINE_FLIGHT ||
            templateTransaction.productType === TransactionProductType.AIRLINE_AWARD
          ) && templateTransaction.status !== TransactionStatus.PARTNER_REJECT
        "
      >
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.description.description' | finLocalization }}
        </th>
        <td class="medium-type align-right">
          {{ templateTransaction.description }}
          <span *ngIf="templateTransaction.productType === TransactionProductType.ELECTRONIC_VOUCHER">
            — {{ 'plus.transactionHistory.modal.description.used' | finLocalization }}</span
          >
        </td>
      </tr>
    </table>

    <!--End of description-->
    <div class="border-top-dashed fill"></div>
    <!--Start of points-->
    <table class="fill ms-large-b">
      <caption class="nordic-blue-900-text ps-large-t align-left bold-type ps-small-b">
        <ng-template #aviosContent let-context="context">
          {{
            ((transactionAvios$ | async) !== NotificationContextType.TierPointTransaction
              ? 'plus.transactionHistory.modal.points.headingAvios'
              : 'plus.transactionHistory.modal.points.heading'
            ) | finLocalization
          }}
          <fcom-notification
            *ngIf="!(context === NotificationContextType.Avios)"
            class="block regular-type mr-xsmall-t"
            [iconName]="SvgLibraryIcon.INFO_BLOCK"
            [theme]="NotificationTheme.WARNING"
          >
            <ng-container *ngIf="context === NotificationContextType.BetweenAvios; else notAviosBookingTransaction">
              <p [innerHTML]="(promoCta$ | async)?.detailText | resolveLinks | finSafe: 'html'"></p>
            </ng-container>
            <ng-template #notAviosBookingTransaction>
              {{ 'plus.transactionHistory.modal.points.notification' | finLocalization }}
            </ng-template>
          </fcom-notification>
        </ng-template>
        <ng-container *ngTemplateOutlet="aviosContent; context: getNotificationContext(templateTransaction)">
        </ng-container>
      </caption>
      <tr>
        <th scope="row" class="align-left ps-xsmall-y">
          {{
            ((transactionAvios$ | async) !== NotificationContextType.TierPointTransaction
              ? 'LOYALTY.plus.transactionHistory.aviosPoints'
              : 'plus.transactionHistory.modal.points.award'
            ) | finLocalization
          }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.awardPoints | finPoints }}</td>
      </tr>
      <tr>
        <th scope="row" class="align-left ps-xsmall-y">
          {{ 'plus.transactionHistory.modal.points.tier' | finLocalization }}
        </th>
        <td class="medium-type align-right">{{ templateTransaction.tierPoints | finPoints }}</td>
      </tr>
    </table>

    <!--End of points-->
  </div>
</fcom-modal>

<fcom-modal
  [title]="'plus.transactionHistory.infoModal.title' | finLocalization"
  [(open)]="isInfoModalOpen"
  [buttons]="ModalButtons.CLOSE"
  (close)="closeInfoModal()"
>
  <div class="ps-large font-body-1 light-type">
    <div>
      <h2 class="nordic-blue-900-text font-heading-3 mr-small-b">
        {{ 'plus.transactionHistory.infoModal.awardPoints.heading' | finLocalization }}
      </h2>
      <p class="mr-small-b">
        {{ 'plus.transactionHistory.infoModal.awardPoints.paragraph' | finLocalization }}
      </p>
      <p class="medium-type">
        {{ 'plus.transactionHistory.infoModal.awardPoints.subheading' | finLocalization }}
      </p>
      <ul class="ms-large-l">
        <li class="">{{ 'plus.transactionHistory.infoModal.awardPoints.list.0' | finLocalization }}</li>
        <li class="">{{ 'plus.transactionHistory.infoModal.awardPoints.list.1' | finLocalization }}</li>
        <li class="">{{ 'plus.transactionHistory.infoModal.awardPoints.list.2' | finLocalization }}</li>
      </ul>
    </div>
    <div>
      <h2 class="nordic-blue-900-text font-heading-3 mr-small-b">
        {{ 'plus.transactionHistory.infoModal.tierPoints.heading' | finLocalization }}
      </h2>
      <p class="mr-small-b">
        {{ 'plus.transactionHistory.infoModal.tierPoints.paragraph' | finLocalization }}
      </p>
      <ul class="ms-large-l">
        <li class="">{{ 'plus.transactionHistory.infoModal.tierPoints.list.0' | finLocalization }}</li>
        <li class="">{{ 'plus.transactionHistory.infoModal.tierPoints.list.1' | finLocalization }}</li>
      </ul>
    </div>
  </div>
</fcom-modal>
